module.exports = __webpack_public_path__ + "static/tt-desktop-futures-screen-b3d428e1d46f6405ec1f09ead124244f.png";